/*
* identity function that performs a this context binding on a function
*
* the reason for this is because the native ts function.prototype.bind() is implemented
* with any and loses types on the bound function
* */
export default (thisContext: any) =>
  <F> (func: F): F =>
    (func as any).bind(thisContext)



// WEBPACK FOOTER //
// ./src/utils/bind.ts